import { RouteConfig, SideLink } from '@/types/utility.types'
import {
  IconHome,
  IconListNumbers,
  IconBuildingWarehouse,
  IconRepeat,
  IconStar,
  IconUsers,
} from '@tabler/icons-react'

export const warehouseModuleKey = 'warehouse'
export const warehouseOrderingKey = 'warehouse_ordering'
export const warehouseWorkersModuleKey = 'worker'
export const warehouseRatingModuleKey = 'rating'
export const autoTransferModuleKey = 'auto_transfer'

const warehouseRoute: RouteConfig = {
  uid: warehouseModuleKey,
  path: 'warehouse/warehouses-list',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/warehouses/warehouses')).default,
  }),
}

const createWarehouseRoute: RouteConfig = {
  uid: warehouseModuleKey,
  path: 'warehouse/warehouses-list/create',
  type: 'create',
  lazy: async () => ({
    Component: (await import('@/pages/warehouses/warehouses/create')).default,
  }),
}

const editWarehouseRoute: RouteConfig = {
  uid: warehouseModuleKey,
  path: 'warehouse/warehouses-list/:warehouseId',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/warehouses/warehouses/edit')).default,
  }),
}

const warehouseOrderingRoute: RouteConfig = {
  uid: warehouseOrderingKey,
  path: 'warehouse/warehouses-ordering',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/warehouses/warehouse-ordering')).default,
  }),
}

const editWarehouseOrderingRoute: RouteConfig = {
  uid: warehouseOrderingKey,
  path: 'warehouse/warehouses-ordering/:warehouseId',
  type: 'update',
  lazy: async () => ({
    Component: (await import('@/pages/warehouses/warehouse-ordering/edit'))
      .default,
  }),
}

const warehouseWorkersRoute: RouteConfig = {
  uid: warehouseWorkersModuleKey,
  path: 'warehouse/warehouse-workers',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/warehouses/warehouse-workers')).default,
  }),
}

const warehouseWorkersCreateRoute: RouteConfig = {
  uid: warehouseWorkersModuleKey,
  path: 'warehouse/warehouse-workers/create',
  type: 'create',
  lazy: async () => ({
    Component: (await import('@/pages/warehouses/warehouse-workers/create'))
      .default,
  }),
}

const warehouseWorkersEditRoute: RouteConfig = {
  uid: warehouseWorkersModuleKey,
  path: 'warehouse/warehouse-workers/:workerId',
  type: 'update',
  lazy: async () => ({
    Component: (await import('@/pages/warehouses/warehouse-workers/edit'))
      .default,
  }),
}

const warehouseRatingRoute: RouteConfig = {
  uid: warehouseRatingModuleKey,
  path: 'warehouse/warehouse-rating',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/warehouses/warehouse-rating')).default,
  }),
}

const warehouseRatingDetailRoute: RouteConfig = {
  uid: warehouseRatingModuleKey,
  path: 'warehouse/warehouse-rating/:warehouseId',
  type: 'retrieve',
  lazy: async () => ({
    Component: (await import('@/pages/warehouses/warehouse-rating-detail'))
      .default,
  }),
}

const autoTransferRoute: RouteConfig = {
  uid: autoTransferModuleKey,
  path: 'warehouse/auto-transfer',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/warehouses/auto-transfer')).default,
  }),
}

export const sidelink: SideLink = {
  title: 'Warehouse',
  href: 'warehouse',
  icon: <IconHome size={18} />,
  order: 7,
  sub: [
    {
      uid: warehouseModuleKey,
      title: 'Warehouses',
      href: 'warehouse/warehouses-list',
      icon: <IconBuildingWarehouse size={18} />,
      order: 1,
    },
    {
      uid: warehouseOrderingKey,
      title: 'Warehouse Ordering',
      href: 'warehouse/warehouses-ordering',
      icon: <IconListNumbers size={18} />,
      order: 2,
    },
    {
      uid: warehouseWorkersModuleKey,
      title: 'warehouse_workers',
      href: 'warehouse/warehouse-workers',
      icon: <IconUsers size={18} />,
      order: 3,
    },
    {
      uid: warehouseRatingModuleKey,
      title: 'warehouse_rating',
      href: 'warehouse/warehouse-rating',
      icon: <IconStar size={18} />,
      order: 4,
    },
    {
      uid: autoTransferModuleKey,
      title: 'auto_transfer',
      href: 'warehouse/auto-transfer',
      icon: <IconRepeat size={18} />,
      order: 5,
    },
  ],
}

export default [
  warehouseRoute,
  createWarehouseRoute,
  editWarehouseRoute,
  warehouseOrderingRoute,
  editWarehouseOrderingRoute,
  warehouseWorkersRoute,
  warehouseWorkersCreateRoute,
  warehouseWorkersEditRoute,
  warehouseRatingRoute,
  warehouseRatingDetailRoute,
  autoTransferRoute,
]
